import { Component } from '@angular/core';

@Component({
    selector: 'lib-frontend-settings',
    templateUrl: './frontend-settings.component.html',
    styleUrls: ['./frontend-settings.component.css'],
    standalone: false
})
export class FrontendSettingsComponent {
  doneLoading = false;

}
